import styled from 'styled-components';

import HyroxLogo from 'src/app/ui/components/atoms/icons/hyrox-logo';
import PoweredByFiit from 'app/ui/components/atoms/powered-by-fiit';
import Typography from 'app/ui/components/atoms/typography';

export const FooterWrapper = styled.div`
  display: none;

  ${({ theme: { media, spacing } }) => `${media.medium(
    () => `
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      position: absolute;
      width: 100%;
      bottom: 0;
      left: 0;
      gap: ${spacing(14)};
      padding: ${spacing(4)} ${spacing(6)} ${spacing(6)};
    `,
  )}
  `};
`;

export const LessonTitle = styled(Typography)`
  text-transform: uppercase;
`;

export const LogosWrapper = styled.div<{ $isPresenterView?: boolean }>`
  display: none;
  flex-direction: row;
  align-items: flex-start;
  position: absolute;
  ${({ $isPresenterView }) => ($isPresenterView ? 'top: 0;' : 'bottom: 0;')};
  right: 0;
  gap: ${({ theme }) => theme.spacing(14)};
  padding: ${({ theme }) => theme.spacing(8)};

  ${({ theme: { media } }) => `${media.medium(
    () => `
      display: flex;
    `,
  )}
  `};
`;

export const LargeHyroxLogo = styled(HyroxLogo)`
  width: 8rem;
  height: auto;
`;

export const LargePoweredByFiit = styled(PoweredByFiit)`
  width: 12rem;
  height: auto;
`;
